// extracted by mini-css-extract-plugin
export default {"internalLayout":"create_internalLayout__pnYoN","formContainer":"create_formContainer__-vQ-f","footerActions":"create_footerActions__z33iX"};